import { render, staticRenderFns } from "./backTopBtn.vue?vue&type=template&id=2aa85f0b&scoped=true"
import script from "./backTopBtn.vue?vue&type=script&lang=js"
export * from "./backTopBtn.vue?vue&type=script&lang=js"
import style0 from "./backTopBtn.vue?vue&type=style&index=0&id=2aa85f0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa85f0b",
  null
  
)

export default component.exports